module.exports = __webpack_public_path__ + "static/media/benefit_two.ad759454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/benefits/benefit_two.png
// module id = 1443
// module chunks = 0